import { create } from "zustand";
import { RolePermissions } from "../models/role";

interface RolePermissionsState {
  rolePermissions: RolePermissions | null;
  setRolePermissions: (rolePermissions: RolePermissions) => void;
}

export const useRolePermissionsStore = create<RolePermissionsState>((set) => ({
  rolePermissions: null,
  setRolePermissions: (rolePermissions: RolePermissions) =>
    set({ rolePermissions: rolePermissions }),
}));
